import React from "react";
import { ARROW, ARROW_POINTER, WOMAN } from "../../../utils-func/image_exports";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { swiperData } from "../../../constants";
import { motion } from "framer-motion";
import { Bounce } from "react-awesome-reveal";
function HowItWorks() {
  return (
    <div id="how-it-works" className="lg:px-16 px-5 mt-20">
      <div className="flex lg:flex-row flex-col-reverse items-start justify-between">
        <motion.img
          initial={{ rotateX: -90, opacity: 0 }}
          whileInView={{ rotateX: 0, opacity: 1 }}
          transition={{ duration: 2, ease: "easeInOut" }}
          viewport={{ once: true }}
          src={WOMAN}
          className="w-[702px] h-[373px] object-cover"
          style={{ borderRadius: "30px" }}
          alt=""
        />
        <div className="flex flex-col gap-y-20 lg:items-end items-start">
          <div className="flex lg:items-end items-start lg:w-[365px] w-full justify-end gap-y-3 flex-col">
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
              viewport={{ once: true }}
              className="text-[49px] font-medium"
            >
              How It Works
            </motion.span>
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
              viewport={{ once: true }}
              className="text-xl font-normal text-end"
            >
              The entire process is easy, get <br /> started with using the
              platform
            </motion.span>
          </div>
          <Bounce duration={1000}>
            <div className="custom-next-button">
              <img
                src={ARROW}
                className=" w-[100px] h-[100px] object-contain hover:scale-95 transition-all duration-300 cursor-pointer"
                alt=""
              />
            </div>
          </Bounce>
        </div>
      </div>
      <div className="mt-20">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          breakpoints={{
            1024: { slidesPerView: 4 }, // For desktop
            640: { slidesPerView: 3 }, // For tablets
            320: { slidesPerView: 1 }, // For mobile
          }}
          navigation={{
            nextEl: ".custom-next-button",
            prevEl: ".custom-prev-button",
          }}
        >
          {swiperData.map((item, index) => (
            <SwiperSlide key={index}>
              <motion.div
                initial={{ rotateY: -90, opacity: 0 }}
                whileInView={{ rotateY: 0, opacity: 1 }}
                transition={{ duration: 2, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="w-[280px] h-[280px] p-10 rounded-full flex items-center justify-center"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(224, 209, 92, 0.2) -29.5%, rgba(255, 255, 255, 0) 100%)",
                }}
              >
                <div className="flex flex-col gap-y-2 items-center">
                  <span className="text-[#464646] text-center font-bold text-lg">
                    {item.title}
                  </span>
                  <span className="text-center">{item.para}</span>
                </div>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default HowItWorks;
